(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mmx-coming-soon"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.mmx-coming-soon__form').forEach((form) => {
    const tagsHidden = form.querySelector('[data-mmx-tags-hidden]');
    const phoneInput = form.querySelector('[data-mmx-phone]');
    const instagramInput = form.querySelector('[data-mmx-instagram]');

    if (!tagsHidden || !phoneInput || !instagramInput) return;

    form.addEventListener('submit', () => {
      const tags = tagsHidden.value
        .split(',')
        .map((tag) => tag.trim())
        .filter(Boolean);
      const phone = phoneInput.value.trim();
      const instagram = instagramInput.value.trim();

      if (phone) tags.push(`Phone: +1 ${phone}`);
      if (instagram) tags.push(`Instagram: ${instagram}`);

      tagsHidden.value = tags.join(', ');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mmx-product-information"] && !Shopify.designMode) return;
  try {
    
  /**
   * Renders a number with the visitor's locale separators (3597 -> 3,597).
   */
  class MmxNumber extends HTMLElement {
    connectedCallback() {
      const value = Number(this.dataset.value);

      if (Number.isFinite(value)) this.textContent = value.toLocaleString();
    }
  }

  /**
   * The flavour picker. A disclosure button plus a list of links to other
   * products; each row is tinted with that product's `custom.color` metafield
   * on hover (supplied as `--mmx-pdp-option-accent` by the section's styles).
   */
  class MmxProductSelect extends HTMLElement {
    constructor() {
      super();
      this.onToggleClick = this.onToggleClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onDocumentPointerDown = this.onDocumentPointerDown.bind(this);
    }

    connectedCallback() {
      this.toggle = this.querySelector('[data-mmx-select-toggle]');
      this.list = this.querySelector('[data-mmx-select-list]');
      if (!this.toggle || !this.list) return;

      this.links = Array.from(this.list.querySelectorAll('a'));

      this.toggle.addEventListener('click', this.onToggleClick);
      this.addEventListener('keydown', this.onKeydown);
      document.addEventListener('pointerdown', this.onDocumentPointerDown);
    }

    disconnectedCallback() {
      this.toggle?.removeEventListener('click', this.onToggleClick);
      this.removeEventListener('keydown', this.onKeydown);
      document.removeEventListener('pointerdown', this.onDocumentPointerDown);
    }

    get open() {
      return this.toggle.getAttribute('aria-expanded') === 'true';
    }

    setOpen(open, focusIndex) {
      this.toggle.setAttribute('aria-expanded', String(open));
      this.list.hidden = !open;

      if (open && typeof focusIndex === 'number') {
        this.links[focusIndex]?.focus();
      }
    }

    onToggleClick() {
      this.setOpen(!this.open);
    }

    onDocumentPointerDown(event) {
      if (this.open && !this.contains(event.target)) this.setOpen(false);
    }

    onKeydown(event) {
      const { key } = event;

      if (key === 'Escape' && this.open) {
        event.preventDefault();
        this.setOpen(false);
        this.toggle.focus();
        return;
      }

      const fromToggle = event.target === this.toggle;

      if (fromToggle && (key === 'ArrowDown' || key === 'ArrowUp')) {
        event.preventDefault();
        this.setOpen(true, key === 'ArrowDown' ? 0 : this.links.length - 1);
        return;
      }

      if (!this.open || fromToggle) return;

      const current = this.links.indexOf(event.target);
      if (current === -1) return;

      if (key === 'ArrowDown') {
        event.preventDefault();
        this.links[(current + 1) % this.links.length].focus();
      } else if (key === 'ArrowUp') {
        event.preventDefault();
        this.links[(current - 1 + this.links.length) % this.links.length].focus();
      } else if (key === 'Home') {
        event.preventDefault();
        this.links[0].focus();
      } else if (key === 'End') {
        event.preventDefault();
        this.links[this.links.length - 1].focus();
      } else if (key === 'Tab') {
        this.setOpen(false);
      }
    }
  }

  /**
   * The media gallery: a peeking main carousel synced to a thumbnail strip.
   */
  class MmxProductGallery extends HTMLElement {
    constructor() {
      super();
      this.onBreakpointChange = this.onBreakpointChange.bind(this);
    }

    connectedCallback() {
      this.mainEl = this.querySelector('[data-mmx-gallery-main]');
      if (!this.mainEl) return;

      this.desktopMedia = window.matchMedia('(min-width: 990px)');
      this.desktopMedia.addEventListener('change', this.onBreakpointChange);

      if (typeof Swiper === 'undefined') {
        window.addEventListener('load', () => this.build(), { once: true });
        return;
      }

      this.build();
    }

    disconnectedCallback() {
      this.desktopMedia?.removeEventListener('change', this.onBreakpointChange);
      this.destroySwipers();
    }

    onBreakpointChange() {
      // Rebuild across the breakpoint so the thumbs swiper is never left in a
      // state where it was measured while hidden.
      this.destroySwipers();
      this.build();
    }

    destroySwipers() {
      this.lastActiveIndex = this.mainSwiper?.activeIndex;

      try {
        this.thumbsSwiper?.destroy(true, true);
        this.mainSwiper?.destroy(true, true);
      } catch (error) {
        // Swiper can throw when the host has already left the document.
      }

      this.thumbsSwiper = undefined;
      this.mainSwiper = undefined;
    }

    build() {
      if (typeof Swiper === 'undefined' || this.mainSwiper || !this.isConnected) return;

      const initialSlide = this.lastActiveIndex ?? (parseInt(this.mainEl.dataset.initialSlide, 10) || 0);
      const thumbsEl = this.querySelector('[data-mmx-gallery-thumbs]');

      // Only build the thumbs swiper when its strip is actually visible
      // (desktop). Initializing it while display:none makes Swiper measure
      // zero-sized slides, which corrupts the thumbs link on the main swiper.
      if (thumbsEl && this.desktopMedia.matches) {
        this.thumbsSwiper = new Swiper(thumbsEl, {
          initialSlide: initialSlide,
          slidesPerView: 'auto',
          spaceBetween: 17.6,
          slideToClickedSlide: true,
          watchSlidesProgress: true,
          observer: true,
          observeParents: true,
        });
      }

      const options = {
        initialSlide: initialSlide,
        slidesPerView: 'auto',
        spaceBetween: 13,
        grabCursor: true,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        breakpoints: {
          990: { spaceBetween: 16 },
        },
        navigation: {
          prevEl: this.querySelector('[data-mmx-gallery-prev]'),
          nextEl: this.querySelector('[data-mmx-gallery-next]'),
        },
      };

      if (this.thumbsSwiper) options.thumbs = { swiper: this.thumbsSwiper };

      this.mainSwiper = new Swiper(this.mainEl, options);
    }

    /**
     * Brings the slide for a given media id into view.
     * @param {string|number|null} mediaId
     */
    showMedia(mediaId) {
      if (!this.mainSwiper || mediaId == null) return;

      const index = this.mainSwiper.slides.findIndex(
        (slide) => slide.dataset.mediaId === String(mediaId)
      );

      if (index >= 0) this.mainSwiper.slideTo(index);
    }
  }

  /**
   * The delivery-frequency dropdown inside the subscription purchase option.
   * Picking an option dispatches a bubbling `mmx:plan-change` event that
   * <mmx-product-form> listens for.
   */
  class MmxPlanSelect extends HTMLElement {
    constructor() {
      super();
      this.onToggleClick = this.onToggleClick.bind(this);
      this.onOptionClick = this.onOptionClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onDocumentPointerDown = this.onDocumentPointerDown.bind(this);
    }

    connectedCallback() {
      this.toggle = this.querySelector('[data-mmx-plan-toggle]');
      this.toggleLabel = this.querySelector('[data-mmx-plan-toggle-label]');
      this.list = this.querySelector('[data-mmx-plan-options]');
      if (!this.toggle || !this.list) return;

      this.optionButtons = Array.from(this.list.querySelectorAll('[data-mmx-plan-option]'));

      this.toggle.addEventListener('click', this.onToggleClick);
      this.optionButtons.forEach((option) => option.addEventListener('click', this.onOptionClick));
      this.addEventListener('keydown', this.onKeydown);
      document.addEventListener('pointerdown', this.onDocumentPointerDown);
    }

    disconnectedCallback() {
      this.toggle?.removeEventListener('click', this.onToggleClick);
      this.optionButtons?.forEach((option) => option.removeEventListener('click', this.onOptionClick));
      this.removeEventListener('keydown', this.onKeydown);
      document.removeEventListener('pointerdown', this.onDocumentPointerDown);
    }

    get open() {
      return this.toggle.getAttribute('aria-expanded') === 'true';
    }

    get visibleOptions() {
      return this.optionButtons.filter((option) => !option.hidden);
    }

    setOpen(open, focusIndex) {
      this.toggle.setAttribute('aria-expanded', String(open));
      this.list.hidden = !open;

      if (open && typeof focusIndex === 'number') {
        this.visibleOptions[focusIndex]?.focus();
      }
    }

    /**
     * Marks a plan as active and mirrors its label onto the toggle.
     * @param {string} planId
     */
    setActive(planId) {
      for (const option of this.optionButtons) {
        option.classList.toggle('is-active', option.dataset.planId === planId);
      }

      const active = this.optionButtons.find((option) => option.dataset.planId === planId);
      if (active && this.toggleLabel) this.toggleLabel.textContent = active.textContent.trim();
    }

    onToggleClick() {
      this.setOpen(!this.open);
    }

    /**
     * @param {MouseEvent & {currentTarget: HTMLButtonElement}} event
     */
    onOptionClick(event) {
      const planId = event.currentTarget.dataset.planId;
      if (!planId) return;

      this.setActive(planId);
      this.setOpen(false);
      this.toggle.focus();
      this.dispatchEvent(new CustomEvent('mmx:plan-change', { bubbles: true, detail: { planId } }));
    }

    onDocumentPointerDown(event) {
      if (this.open && !this.contains(event.target)) this.setOpen(false);
    }

    onKeydown(event) {
      const { key } = event;

      if (key === 'Escape' && this.open) {
        event.preventDefault();
        this.setOpen(false);
        this.toggle.focus();
        return;
      }

      const fromToggle = event.target === this.toggle;

      if (fromToggle && (key === 'ArrowDown' || key === 'ArrowUp')) {
        event.preventDefault();
        this.setOpen(true, key === 'ArrowDown' ? 0 : this.visibleOptions.length - 1);
        return;
      }

      if (!this.open || fromToggle) return;

      const options = this.visibleOptions;
      const current = options.indexOf(event.target);
      if (current === -1) return;

      if (key === 'ArrowDown') {
        event.preventDefault();
        options[(current + 1) % options.length].focus();
      } else if (key === 'ArrowUp') {
        event.preventDefault();
        options[(current - 1 + options.length) % options.length].focus();
      } else if (key === 'Home') {
        event.preventDefault();
        options[0].focus();
      } else if (key === 'End') {
        event.preventDefault();
        options[options.length - 1].focus();
      } else if (key === 'Tab') {
        this.setOpen(false);
      }
    }
  }

  /**
   * Owns variant resolution for the custom pack pills and purchase options.
   * Cart submission itself stays with the theme's <product-form-component>;
   * this element only keeps the hidden `id` / `selling_plan` inputs, the
   * displayed prices and the add-to-cart button in sync.
   */
  class MmxProductForm extends HTMLElement {
    constructor() {
      super();
      this.onOptionChange = this.onOptionChange.bind(this);
      this.onPlanChange = this.onPlanChange.bind(this);
      this.onPlanSelectChange = this.onPlanSelectChange.bind(this);
    }

    connectedCallback() {
      const payload = this.querySelector('[data-mmx-variant-data]');

      try {
        this.variants = JSON.parse(payload?.textContent || '{}').variants || [];
      } catch (error) {
        this.variants = [];
      }

      this.optionInputs = Array.from(this.querySelectorAll('[data-mmx-option-input]'));
      this.packs = Array.from(this.querySelectorAll('.mmx-pdp__pack'));
      this.planRows = Array.from(this.querySelectorAll('[data-mmx-plan-row]'));
      this.planInputs = Array.from(this.querySelectorAll('[data-mmx-plan-input]'));
      this.variantIdInput = this.querySelector('[data-mmx-variant-id]');
      this.sellingPlanInput = this.querySelector('[data-mmx-selling-plan]');
      this.addToCartButton = this.querySelector('[data-mmx-atc]');
      this.subRow = this.querySelector('[data-mmx-sub-row]');
      this.subInput = this.querySelector('[data-mmx-sub-input]');
      this.planSelect = this.querySelector('mmx-plan-select');
      this.planUnavailable = false;
      this.optionCount = this.optionInputs.length
        ? Math.max(...this.optionInputs.map((input) => Number(input.dataset.mmxOptionIndex))) + 1
        : 0;

      this.optionInputs.forEach((input) => input.addEventListener('change', this.onOptionChange));
      this.planInputs.forEach((input) => input.addEventListener('change', this.onPlanChange));
      this.addEventListener('mmx:plan-change', this.onPlanSelectChange);

      this.syncSellingPlan();
      this.render(this.resolveVariant(), { updateUrl: false, updateMedia: false });
    }

    disconnectedCallback() {
      this.optionInputs?.forEach((input) => input.removeEventListener('change', this.onOptionChange));
      this.planInputs?.forEach((input) => input.removeEventListener('change', this.onPlanChange));
      this.removeEventListener('mmx:plan-change', this.onPlanSelectChange);
    }

    /** @returns {(string|undefined)[]} the selected value for each option index */
    get selectedOptions() {
      const values = new Array(this.optionCount).fill(undefined);

      for (const input of this.optionInputs) {
        if (input.checked) values[Number(input.dataset.mmxOptionIndex)] = input.value;
      }

      return values;
    }

    /**
     * @param {(string|undefined)[]} [options]
     * @returns {object|undefined}
     */
    resolveVariant(options = this.selectedOptions) {
      if (!this.optionCount) {
        // No variant picker rendered — trust the server-selected variant.
        const currentId = Number(this.variantIdInput?.value);
        return this.variants.find((variant) => variant.id === currentId) ?? this.variants[0];
      }

      return this.variants.find((variant) => this.matches_(variant, options));
    }

    /**
     * @param {object} variant
     * @param {(string|undefined)[]} options
     * @returns {boolean}
     */
    matches_(variant, options) {
      return options.every((value, index) => value === undefined || variant.options[index] === value);
    }

    onOptionChange() {
      this.render(this.resolveVariant());
    }

    onPlanChange() {
      this.syncSellingPlan();
    }

    /**
     * A new delivery frequency was picked in the dropdown.
     * @param {CustomEvent} event
     */
    onPlanSelectChange(event) {
      const planId = event.detail?.planId;
      if (!planId) return;

      if (this.subInput && !this.subInput.checked) this.subInput.checked = true;
      this.setSubscriptionPlan(planId);
      this.render(this.resolveVariant(), { updateUrl: false, updateMedia: false });
    }

    /**
     * Points the subscription row (radio value, price lookup, dropdown) at a plan.
     * @param {string} planId
     */
    setSubscriptionPlan(planId) {
      if (!this.subRow) return;

      this.subRow.dataset.planId = planId;
      if (this.subInput) this.subInput.value = planId;
      this.planSelect?.setActive(planId);
      this.syncSellingPlan();
    }

    /** Mirrors the visible purchase option onto the hidden form input. */
    syncSellingPlan() {
      if (!this.sellingPlanInput) return;

      const checked = this.planInputs.find((input) => input.checked && !input.disabled);
      const planId = checked?.value || '';

      this.sellingPlanInput.value = planId;
      // A blank `selling_plan` is not a valid cart param, so drop the input
      // from the submission entirely for one-time purchases.
      this.sellingPlanInput.disabled = planId === '';
    }

    /**
     * @param {object|undefined} variant
     * @param {object} [options] - `updateUrl` and `updateMedia` both default to true.
     */
    render(variant, { updateUrl = true, updateMedia = true } = {}) {
      this.renderPackAvailability();

      if (this.variantIdInput) this.variantIdInput.value = variant?.id ?? '';

      this.renderPlanOptions(variant);
      this.renderPrices(variant);
      this.renderAddToCart(variant);

      if (updateUrl) this.updateUrl(variant);
      if (updateMedia) this.closest('.mmx-pdp')?.querySelector('mmx-product-gallery')?.showMedia(variant?.mediaId);
    }

    /**
     * Hides frequency options the variant cannot be bought on, and moves the
     * subscription row to another available plan when the current one dies.
     * @param {object|undefined} variant
     */
    renderPlanOptions(variant) {
      if (!this.subRow || !this.planSelect?.optionButtons) return;

      for (const option of this.planSelect.optionButtons) {
        option.hidden = !variant?.plans?.[option.dataset.planId];
      }

      if (variant && !variant.plans?.[this.subRow.dataset.planId]) {
        const fallback = this.planSelect.optionButtons.find((option) => !option.hidden);
        if (fallback) this.setSubscriptionPlan(fallback.dataset.planId);
      }
    }

    /** Strikes through pack values that lead to an unavailable variant. */
    renderPackAvailability() {
      const selected = this.selectedOptions;

      for (const pack of this.packs) {
        const input = pack.querySelector('[data-mmx-option-input]');
        if (!input) continue;

        const candidate = selected.slice();
        candidate[Number(input.dataset.mmxOptionIndex)] = input.value;

        pack.dataset.available = String(
          this.variants.some((variant) => variant.available && this.matches_(variant, candidate))
        );
      }
    }

    /**
     * @param {object|undefined} variant
     */
    renderPrices(variant) {
      let checkedRowHidden = false;
      this.planUnavailable = false;

      for (const row of this.planRows) {
        const planId = row.dataset.planId;
        const input = row.querySelector('[data-mmx-plan-input]');
        const allocation = planId ? variant?.plans?.[planId] : undefined;

        // A selling plan with no allocation for this variant cannot be bought.
        if (planId) {
          row.hidden = !allocation;
          const box = row.closest('.mmx-pdp__planbox');
          if (box) box.hidden = row.hidden;
          if (input) input.disabled = row.hidden;
          if (row.hidden && input?.checked) checkedRowHidden = true;
        }

        const price = planId ? allocation?.price : variant?.price;
        const priceNode = row.querySelector('[data-mmx-plan-price]');
        if (priceNode && price) priceNode.innerHTML = price;

        const save = planId ? allocation?.save ?? 0 : 0;
        const saveNode = row.querySelector('[data-mmx-save]');
        const saveValue = row.querySelector('[data-mmx-save-value]');
        if (saveNode) saveNode.hidden = !save;
        if (saveValue && save) saveValue.textContent = String(save);

        const compare = planId ? allocation?.compare : '';
        const compareNode = row.querySelector('[data-mmx-plan-compare]');
        if (compareNode) {
          compareNode.hidden = !compare;
          compareNode.innerHTML = compare || '';
        }
      }

      if (checkedRowHidden) this.selectFallbackPlan();
    }

    /** Moves the selection off a plan the current variant cannot be bought on. */
    selectFallbackPlan() {
      const rows = this.planRows.filter((row) => !row.hidden);
      // Prefer the one-time row (blank plan id), which is always purchasable.
      const target = rows.find((row) => !row.dataset.planId) ?? rows[0];
      const input = target?.querySelector('[data-mmx-plan-input]');

      if (!input) {
        // Subscription-only product with no valid plan for this variant:
        // block the submission instead of sending a stale selling_plan.
        this.planUnavailable = true;

        if (this.sellingPlanInput) {
          this.sellingPlanInput.value = '';
          this.sellingPlanInput.disabled = true;
        }

        return;
      }

      input.checked = true;
      this.syncSellingPlan();
    }

    /**
     * @param {object|undefined} variant
     */
    renderAddToCart(variant) {
      const button = this.addToCartButton;
      if (!button) return;

      const { labelAdd, labelSoldOut, labelUnavailable } = button.dataset;

      button.disabled = !variant?.available || this.planUnavailable;
      button.textContent =
        !variant || this.planUnavailable
          ? labelUnavailable || 'Unavailable'
          : variant.available
          ? labelAdd || 'Add to cart'
          : labelSoldOut || 'Sold out';
    }

    /**
     * @param {object|undefined} variant
     */
    updateUrl(variant) {
      if (!variant) return;

      const url = new URL(window.location.href);
      url.searchParams.set('variant', String(variant.id));

      if (url.href !== window.location.href) history.replaceState({}, '', url.toString());
    }
  }

  /**
   * The floating add-to-cart bar. Slides in once the main product area has
   * been scrolled past; its pack pills switch which variant gets added.
   */
  class MmxFloatCart extends HTMLElement {
    constructor() {
      super();
      this.onPillClick = this.onPillClick.bind(this);
    }

    connectedCallback() {
      this.pills = Array.from(this.querySelectorAll('[data-mmx-fc-pill]'));
      this.variantInput = this.querySelector('[data-mmx-fc-variant]');
      this.priceNode = this.querySelector('[data-mmx-fc-price]');
      this.compareNode = this.querySelector('[data-mmx-fc-compare]');
      this.atcButton = this.querySelector('[data-mmx-fc-atc]');

      this.pills.forEach((pill) => pill.addEventListener('click', this.onPillClick));

      const target = this.closest('.mmx-pdp')?.querySelector('.mmx-pdp__layout');

      if (target) {
        this.observer = new IntersectionObserver((entries) => {
          const entry = entries[0];
          if (!entry) return;

          // Visible only once the product area sits fully above the viewport.
          const passed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          this.classList.toggle('is-visible', passed);
        });

        this.observer.observe(target);
      }
    }

    disconnectedCallback() {
      this.pills?.forEach((pill) => pill.removeEventListener('click', this.onPillClick));
      this.observer?.disconnect();
      this.observer = undefined;
    }

    /**
     * @param {MouseEvent & {currentTarget: HTMLButtonElement}} event
     */
    onPillClick(event) {
      const pill = event.currentTarget;

      for (const candidate of this.pills) {
        const active = candidate === pill;
        candidate.classList.toggle('is-active', active);
        candidate.setAttribute('aria-pressed', String(active));
      }

      if (this.variantInput) this.variantInput.value = pill.dataset.variantId || '';
      if (this.priceNode && pill.dataset.price) this.priceNode.innerHTML = pill.dataset.price;

      if (this.compareNode) {
        const compare = pill.dataset.compare || '';
        this.compareNode.hidden = !compare;
        this.compareNode.innerHTML = compare;
      }

      if (this.atcButton) this.atcButton.disabled = pill.dataset.available !== 'true';
    }
  }

  if (!customElements.get('mmx-number')) {
    customElements.define('mmx-number', MmxNumber);
  }

  if (!customElements.get('mmx-float-cart')) {
    customElements.define('mmx-float-cart', MmxFloatCart);
  }

  if (!customElements.get('mmx-product-select')) {
    customElements.define('mmx-product-select', MmxProductSelect);
  }

  if (!customElements.get('mmx-plan-select')) {
    customElements.define('mmx-plan-select', MmxPlanSelect);
  }

  if (!customElements.get('mmx-product-gallery')) {
    customElements.define('mmx-product-gallery', MmxProductGallery);
  }

  if (!customElements.get('mmx-product-form')) {
    customElements.define('mmx-product-form', MmxProductForm);
  }

  // Loading state for the add-to-cart buttons: aria-busy goes on at form
  // submit and comes off when the theme's cart round trip settles. The theme's
  // <product-form-component> dispatches a bubbling `shopify:cart:lines-update`
  // event right before the fetch, carrying a promise that resolves once
  // /cart/add responds (success or error).
  (() => {
    const LOADING_TIMEOUT = 10000;
    const timers = new WeakMap();

    const setBusy = (button) => {
      button.setAttribute('aria-busy', 'true');
      clearTimeout(timers.get(button));
      // Safety net: some failures (e.g. quantity validation) never dispatch a
      // cart event, so never leave the spinner running forever.
      timers.set(button, setTimeout(() => clearBusy(button), LOADING_TIMEOUT));
    };

    const clearBusy = (button) => {
      button.removeAttribute('aria-busy');
      clearTimeout(timers.get(button));
    };

    const clearAllBusy = () => {
      document.querySelectorAll('.mmx-pdp button[name="add"][aria-busy="true"]').forEach(clearBusy);
    };

    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.closest('.mmx-pdp')) return;

      const button = form.querySelector('button[name="add"]');
      if (button && !button.disabled) setBusy(button);
    });

    document.addEventListener('shopify:cart:lines-update', (event) => {
      if (!(event.target instanceof Element) || !event.target.closest('.mmx-pdp')) return;

      if (event.promise) {
        event.promise.then(clearAllBusy, clearAllBusy);
      } else {
        clearAllBusy();
      }
    });

    document.addEventListener('shopify:cart:error', clearAllBusy);
  })();

  // Theme-editor live updates can patch the section's DOM in place without
  // reconnecting the custom elements, leaving their cached refs stale.
  // Rebuild them whenever the editor reloads a section containing them.
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      event.target
        .querySelectorAll('mmx-product-select, mmx-plan-select, mmx-product-gallery, mmx-product-form, mmx-float-cart')
        .forEach((element) => {
          element.disconnectedCallback?.();
          element.connectedCallback?.();
        });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mmx-product-recommendations"] && !Shopify.designMode) return;
  try {
    
  /**
   * Pack-size pills on a recommendation card: clicking a pill points the
   * card's add-to-cart form and price at that variant.
   */
  class MmxRecCard extends HTMLElement {
    constructor() {
      super();
      this.onPillClick = this.onPillClick.bind(this);
    }

    connectedCallback() {
      this.pills = Array.from(this.querySelectorAll('[data-mmx-rec-pill]'));
      this.variantInput = this.querySelector('[data-mmx-rec-variant]');
      this.priceNode = this.querySelector('[data-mmx-rec-price]');

      this.pills.forEach((pill) => pill.addEventListener('click', this.onPillClick));
    }

    disconnectedCallback() {
      this.pills?.forEach((pill) => pill.removeEventListener('click', this.onPillClick));
    }

    /**
     * @param {MouseEvent & {currentTarget: HTMLButtonElement}} event
     */
    onPillClick(event) {
      const pill = event.currentTarget;

      for (const candidate of this.pills) {
        const active = candidate === pill;
        candidate.classList.toggle('is-active', active);
        candidate.setAttribute('aria-pressed', String(active));
      }

      if (this.variantInput) this.variantInput.value = pill.dataset.variantId || '';
      if (this.priceNode && pill.dataset.price) this.priceNode.innerHTML = pill.dataset.price;

      const button = this.querySelector('[data-mmx-rec-atc]');
      if (button) button.disabled = pill.dataset.available !== 'true';
    }
  }

  /**
   * Mobile carousel: centered peeking slides with the info/cart panel below
   * following the active slide.
   */
  class MmxRecCarousel extends HTMLElement {
    connectedCallback() {
      this.swiperEl = this.querySelector('[data-mmx-rec-swiper]');
      if (!this.swiperEl) return;

      if (typeof Swiper === 'undefined') {
        window.addEventListener('load', () => this.build(), { once: true });
        return;
      }

      this.build();
    }

    disconnectedCallback() {
      try {
        this.swiper?.destroy(true, true);
      } catch (error) {
        // Swiper can throw when the host already left the document.
      }

      this.swiper = undefined;
    }

    build() {
      if (typeof Swiper === 'undefined' || this.swiper || !this.isConnected) return;

      const panels = Array.from(this.querySelectorAll('.mmx-rec__panel'));
      const originalCount = parseInt(this.swiperEl.dataset.originalSlideCount, 10) || 0;

      // Same configuration as mm-featured-products' mobile carousel.
      this.swiper = new Swiper(this.swiperEl, {
        slidesPerView: 2,
        spaceBetween: 20,
        centeredSlides: true,
        grabCursor: true,
        loop: originalCount > 1,
        loopAddBlankSlides: false,
        slideToClickedSlide: true,
        navigation: {
          prevEl: this.querySelector('[data-mmx-rec-prev]'),
          nextEl: this.querySelector('[data-mmx-rec-next]'),
        },
      });

      const getActiveIndex = () => {
        const active = this.swiperEl.querySelector('.swiper-slide-active');

        if (active) {
          const slideIndex = parseInt(active.getAttribute('data-slide-index'), 10);
          if (Number.isInteger(slideIndex) && slideIndex >= 0 && slideIndex < panels.length) {
            return slideIndex;
          }
        }

        const realIndex = this.swiper.realIndex;
        if (Number.isInteger(realIndex) && realIndex >= 0 && panels.length > 0) {
          return realIndex % panels.length;
        }

        return 0;
      };

      const sync = () => {
        const activeIndex = getActiveIndex();

        panels.forEach((panel, i) => {
          panel.classList.toggle('is-active', i === activeIndex);
        });
      };

      this.swiper.on('slideChangeTransitionEnd', sync);
      sync();
    }
  }

  if (!customElements.get('mmx-rec-card')) {
    customElements.define('mmx-rec-card', MmxRecCard);
  }

  if (!customElements.get('mmx-rec-carousel')) {
    customElements.define('mmx-rec-carousel', MmxRecCarousel);
  }

  // Add-to-cart loading state, same contract as the PDP section: busy from
  // submit until the theme's cart round trip settles.
  (() => {
    if (window.__mmxRecLoadingBound) return;
    window.__mmxRecLoadingBound = true;

    const LOADING_TIMEOUT = 10000;
    const timers = new WeakMap();

    const clearBusy = (button) => {
      button.removeAttribute('aria-busy');
      clearTimeout(timers.get(button));
    };

    const clearAllBusy = () => {
      document.querySelectorAll('.mmx-rec button[name="add"][aria-busy="true"]').forEach(clearBusy);
    };

    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.closest('.mmx-rec')) return;

      const button = form.querySelector('button[name="add"]');
      if (!button || button.disabled) return;

      button.setAttribute('aria-busy', 'true');
      clearTimeout(timers.get(button));
      timers.set(button, setTimeout(() => clearBusy(button), LOADING_TIMEOUT));
    });

    document.addEventListener('shopify:cart:lines-update', (event) => {
      if (!(event.target instanceof Element) || !event.target.closest('.mmx-rec')) return;

      if (event.promise) {
        event.promise.then(clearAllBusy, clearAllBusy);
      } else {
        clearAllBusy();
      }
    });

    document.addEventListener('shopify:cart:error', clearAllBusy);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mmx-read-the-label"] && !Shopify.designMode) return;
  try {
    
  /**
   * Arrow controls for the mobile benefits strip. The strip itself is a
   * native scroll container; the arrows scroll it one item at a time.
   */
  class MmxRtlCarousel extends HTMLElement {
    constructor() {
      super();
      this.onPrev = this.onPrev.bind(this);
      this.onNext = this.onNext.bind(this);
      this.onScroll = this.onScroll.bind(this);
    }

    connectedCallback() {
      this.track = this.querySelector('.mmx-rtl__benefits-track');
      this.prev = this.querySelector('[data-mmx-rtl-prev]');
      this.next = this.querySelector('[data-mmx-rtl-next]');
      if (!this.track) return;

      this.prev?.addEventListener('click', this.onPrev);
      this.next?.addEventListener('click', this.onNext);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });

      this.updateArrows();
    }

    disconnectedCallback() {
      this.prev?.removeEventListener('click', this.onPrev);
      this.next?.removeEventListener('click', this.onNext);
      this.track?.removeEventListener('scroll', this.onScroll);
    }

    get step() {
      const item = this.track.querySelector('.mmx-rtl__benefit');
      return item ? item.offsetWidth + 16 : Math.round(this.track.clientWidth * 0.8);
    }

    onPrev() {
      this.track.scrollBy({ left: -this.step, behavior: 'smooth' });
    }

    onNext() {
      this.track.scrollBy({ left: this.step, behavior: 'smooth' });
    }

    onScroll() {
      if (this.scrollFrame) return;

      this.scrollFrame = requestAnimationFrame(() => {
        this.scrollFrame = undefined;
        this.updateArrows();
      });
    }

    updateArrows() {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth - 1;

      if (this.prev) this.prev.disabled = this.track.scrollLeft <= 0;
      if (this.next) this.next.disabled = this.track.scrollLeft >= maxScroll;
    }
  }

  if (!customElements.get('mmx-rtl-carousel')) {
    customElements.define('mmx-rtl-carousel', MmxRtlCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mmx-varity-comparison"] && !Shopify.designMode) return;
  try {
    
  /**
   * The variety comparison carousel: one comparison table per flavour in a
   * native scroll-snap track, driven by arrows, pagination bars, the
   * keyboard and touch swipes.
   */
  class MmxVcmpCarousel extends HTMLElement {
    constructor() {
      super();
      this.onScroll = this.onScroll.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onPrev = () => this.goTo(this.index - 1);
      this.onNext = () => this.goTo(this.index + 1);
      this.onDotClick = this.onDotClick.bind(this);
    }

    connectedCallback() {
      this.track = this.querySelector('[data-mmx-vcmp-track]');
      this.slides = Array.from(this.querySelectorAll('[data-mmx-vcmp-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-mmx-vcmp-dot]'));
      this.prev = this.querySelector('[data-mmx-vcmp-prev]');
      this.next = this.querySelector('[data-mmx-vcmp-next]');
      if (!this.track || this.slides.length < 2) return;

      this.index = 0;
      this.prev?.addEventListener('click', this.onPrev);
      this.next?.addEventListener('click', this.onNext);
      this.dots.forEach((dot) => dot.addEventListener('click', this.onDotClick));
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.addEventListener('keydown', this.onKeydown);

      // Keep the current slide in view when the viewport is resized.
      this.resizeObserver = new ResizeObserver(() => {
        this.track.scrollTo({ left: this.slides[this.index].offsetLeft, behavior: 'instant' });
      });
      this.resizeObserver.observe(this.track);

      this.update();
    }

    disconnectedCallback() {
      this.prev?.removeEventListener('click', this.onPrev);
      this.next?.removeEventListener('click', this.onNext);
      this.dots?.forEach((dot) => dot.removeEventListener('click', this.onDotClick));
      this.track?.removeEventListener('scroll', this.onScroll);
      this.removeEventListener('keydown', this.onKeydown);
      this.resizeObserver?.disconnect();
    }

    goTo(index) {
      const target = Math.max(0, Math.min(index, this.slides.length - 1));
      this.track.scrollTo({ left: this.slides[target].offsetLeft });
    }

    onDotClick(event) {
      this.goTo(this.dots.indexOf(event.currentTarget));
    }

    onKeydown(event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this.onPrev();
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        this.onNext();
      }
    }

    onScroll() {
      if (this.scrollFrame) return;

      this.scrollFrame = requestAnimationFrame(() => {
        this.scrollFrame = undefined;
        const width = this.track.clientWidth || 1;
        this.index = Math.max(0, Math.min(Math.round(this.track.scrollLeft / width), this.slides.length - 1));
        this.update();
      });
    }

    update() {
      this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.index)));
      this.slides.forEach((slide, i) => slide.toggleAttribute('inert', i !== this.index));
      if (this.prev) this.prev.disabled = this.index === 0;
      if (this.next) this.next.disabled = this.index === this.slides.length - 1;
    }
  }

  if (!customElements.get('mmx-vcmp-carousel')) {
    customElements.define('mmx-vcmp-carousel', MmxVcmpCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mmx-varity-label"] && !Shopify.designMode) return;
  try {
    
  /**
   * Arrow controls for the mobile benefits strip inside each flavour panel.
   * The strip is a native scroll container; the arrows step it one item at
   * a time. On desktop the strip is a static grid and the arrows are hidden.
   */
  class MmxVlCarousel extends HTMLElement {
    constructor() {
      super();
      this.onPrev = this.onPrev.bind(this);
      this.onNext = this.onNext.bind(this);
      this.onScroll = this.onScroll.bind(this);
    }

    connectedCallback() {
      this.track = this.querySelector('.mmx-vl__benefits-track');
      this.prev = this.querySelector('[data-mmx-vl-prev]');
      this.next = this.querySelector('[data-mmx-vl-next]');
      if (!this.track) return;

      this.prev?.addEventListener('click', this.onPrev);
      this.next?.addEventListener('click', this.onNext);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      // Closed panels have no layout and the strip turns into a grid on
      // desktop, so re-measure whenever the track's size changes.
      this.resizeObserver = new ResizeObserver(this.onScroll);
      this.resizeObserver.observe(this.track);

      this.updateArrows();
    }

    disconnectedCallback() {
      this.prev?.removeEventListener('click', this.onPrev);
      this.next?.removeEventListener('click', this.onNext);
      this.track?.removeEventListener('scroll', this.onScroll);
      this.resizeObserver?.disconnect();
    }

    get step() {
      const item = this.track.querySelector('.mmx-vl__benefit');
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      return item ? item.offsetWidth + gap : Math.round(this.track.clientWidth * 0.8);
    }

    onPrev() {
      this.track.scrollBy({ left: -this.step, behavior: 'smooth' });
    }

    onNext() {
      this.track.scrollBy({ left: this.step, behavior: 'smooth' });
    }

    onScroll() {
      if (this.scrollFrame) return;

      this.scrollFrame = requestAnimationFrame(() => {
        this.scrollFrame = undefined;
        this.updateArrows();
      });
    }

    updateArrows() {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth - 1;

      if (this.prev) this.prev.disabled = this.track.scrollLeft <= 0;
      if (this.next) this.next.disabled = this.track.scrollLeft >= maxScroll;
    }
  }

  if (!customElements.get('mmx-vl-carousel')) {
    customElements.define('mmx-vl-carousel', MmxVlCarousel);
  }

  // Theme editor: open a flavour when its block is selected.
  document.addEventListener('shopify:block:select', (event) => {
    const target = event.target;
    if (target instanceof HTMLDetailsElement && target.classList.contains('mmx-vl__item')) target.open = true;
  });

  } catch(e) { console.error(e); }
})();
})();
